import { AllDataUser, HoursOverTime } from '@pwp-common';

import { RowCell } from '../../../../common/p-table/row-cell';

//////////////////////////////////////////////////////////////////////////////////////////
// Event hours table row
//////////////////////////////////////////////////////////////////////////////////////////

export interface CreateEventHoursRowInput {
  entityId: string;
  hoursOverTime: HoursOverTime;
  allDataUser: AllDataUser | undefined;
}

export const createEventHoursRow = (params: CreateEventHoursRowInput) => ({
  id: params.entityId,
  ...params.hoursOverTime,
  displayName: createValueCell(params.hoursOverTime.displayName),
  isAdmin: createIsAdminCell(params.allDataUser),
  orgNote: createOrgNoteCell(params.allDataUser),
});

//////////////////////////////////////////////////////////////////////////////////////////
// Value cell
//////////////////////////////////////////////////////////////////////////////////////////

export const createValueCell = (value: string): RowCell<string> =>
  new RowCell<string>({
    translationScope: 'event-hours-table',
    translationKey: 'cellValue',
    translationObj: { value },
    sortValue: value,
  });

export const createIsAdminCell = (allDataUser: AllDataUser | undefined): RowCell<string> => {
  const isAdmin = allDataUser?.roles?.isOrgAdmin() ?? false;
  return createValueCell(isAdmin ? 'Yes' : 'No');
};

export const createOrgNoteCell = (allDataUser: AllDataUser | undefined): RowCell<string> =>
  createValueCell(allDataUser?.roles?.getOrgNote() ?? '');
